export enum BridgeColumns {
    SummaryItemType = 'summaryItemType',
    OutstandingAmount = 'outstandingAmount',
    OutstandingNumber = 'outstandingNumber',
    BfiRepaysAmount = 'bfiRepaysAmount',
    BfiRepaysNumber = 'bfiRepaysNumber',
}
